<template>
  <div class="page-expressInterception">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">客服專區</div>
      <div class="breadcrumb-item">包裹拦截</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <!--<FormItem>
          <DatePicker type="date" size="small" placeholder="起始日期" :options="options3" v-model="form.start_time"
                      value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker type="date" size="small" placeholder="結束日期" :options="options3" v-model="form.end_time"
                      value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
        </FormItem>-->

        <Form inline class="pg-form-inline form-input-wrap">
          <FormItem>
            <label class="input-label">用戶電話</label>
            <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">快遞單號</label>
            <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
          </FormItem>
          <FormItem>
            <div class="pg-btn-wrap">
              <div class="pg-btn style1" @click="handleSearch">搜索</div>
              <!--<div class="pg-btn style2" @click="handleExport">导出</div>-->
              <div class="pg-btn style2" @click="handleShowEidt">新增</div>
            </div>
          </FormItem>
        </Form>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table size="small"
             ref="selection"
             border
             no-data-text="暫無數據"
             :columns="table.column"
             :data="table.data">
        <template slot-scope="{ row }" slot="action">
          <div class="pg-btn-wrap">
            <!--<div class="pg-btn style2" @click="handleShowEidt(row)">修改</div>-->
            <div class="pg-btn style1" @click="handleDel(row.id)">刪除</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total mg-r10">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select v-model="curPageSize" size="small" placeholder="數量"
                        @on-change="handlePageSizeChange">
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                       @on-enter="handlePageEnter"/>
              </div>

              <Page size="small"
                    :current="pageIndex"
                    :page-size="curPageSize"
                    :total="totalCount"
                    @on-change="handlePageChange">
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <Modal v-model="showedit"
           title="新增"
           width="400"
           :footer-hide="true">
      <div class="modal-cont">
        <Form>
          <FormItem>
            <label class="input-label">手机号码</label>
            <Input clearable v-model="editForm.phone"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">快遞單號</label>
            <Input clearable v-model="editForm.odd_number"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">拦截原因</label>
            <Input clearable v-model="editForm.order_remark"></Input>
          </FormItem>

          <FormItem>
            <div class="pg-btn-wrap">
              <div class="pg-btn style1" style="width:100%;" @click="handleEidt">確定</div>
            </div>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios';
import Store from '../../../assets/js/store.js'

export default {
  data() {
    return {
      pageIndex: 1,   //页码
      curPageSize: 10,    //一页数量
      totalCount: 0, //总条数
      pageInput: '',  //输入的页码
      form: {
        start_time: '',
        end_time: '',
        phone: '',
        odd_numbers: '',
        // order_number: '',
      },
      editForm: {
        phone: '',
        odd_number: '',
        order_remark: '',
      },
      isSubmiting: false,
      options3: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      showedit: false,
      table: {
        column: [
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            minWidth: 160
          },
	        {
		        title: 'ID',
		        key: 'id',
		        align: 'center',
		        sortable: true,
		        minWidth: 150
	        },
          {
            title: '用戶電話',
            key: 'phone',
            align: 'center',
            sortable: true,
            minWidth: 150
          },
          {
            title: '快遞單號',
            key: 'odd_nuumbers',
            align: 'center',
            sortable: true,
            minWidth: 130
          },{
            title: '拦截原因',
            key: 'order_remark',
            align: 'center',
            sortable: true,
            minWidth: 130
          },
          {
            title: '创建时间',
            key: 'created_at',
            align: 'center',
            minWidth: 160
          },
	        
	        

        ],
        data: []
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 刪除
    handleDel(id) {
      let _this = this
      this.$Modal.confirm({
        title: '警告',
        content: '<p>是否要删除</p>',
        onOk: () => {
          _this.$Rq.requestAuth({
            url: this.$Api.expressinterception_del,
            method: 'post',
            data: {
              id
            }
          }).then((res) => {
            _this.$Message.info(res.msg)
            _this.getList();
          }).catch((err) => {
            _this.$Message.error('服務端異常，請重試')
          });
        },
        onCancel: () => {

        }
      });

    },
    // 修改
    handleShowEidt() {
      this.editForm.phone = ''
      this.editForm.odd_number = ''
      this.editForm.order_remark = ''
      this.showedit = true
    },
    // 確認 修改
    handleEidt() {
      let form = this.editForm
      this.$Rq.requestAuth({
        url: this.$Api.expressinterception_add,
        method: 'post',
        data: {
          odd_nuumbers: form.odd_number,
          phone: form.phone,
	        order_remark: form.order_remark
        }
      }).then((res) => {
        this.$Message.info(res.msg)
        this.showedit = false;
        this.getList();
      }).catch((err) => {
        this.$Message.error('服務端異常，請重試')
      });

    },
    // 导出
    handleExport() {
      let token = localStorage.getItem('jyb_token');
      let form = this.form;
      let params = {
        'Authorization': token,
        start_time: this.formatDate(form.start_time),
        end_time: this.formatDate(form.end_time),
        phone: form.phone,
        odd_numbers: form.odd_numbers,
        order_number: form.order_number,
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      if (new Set(Object.values(this.form)).size === 1) {
        this.$Utils.showTipInfo("請輸入搜索條件");
        return false;
      }
      let a = document.createElement('a')
      a.href = `${this.$Api.exportDailyCountStoreNew}?${formatParams}`
      a.click()
    },
    // 获取列表
    getList() {
      let form = this.form;
      form.start_time = this.formatDate(form.start_time)
      form.end_time = this.formatDate(form.end_time)
      this.isSubmiting = true;
      this.$Rq.requestAuth({
        url: this.$Api.expressinterception_list,
        method: 'get',
        data: {
          ...form,
          offset: (this.pageIndex - 1) * this.curPageSize,
          limit: this.curPageSize
        }
      }).then((res) => {
        console.log(res)
        this.isSubmiting = false;
        if (res.code == 0) {
          this.table.data = res.data.data
          this.totalCount = res.data.count || 0;
        }
      }).catch((err) => {
        this.isSubmiting = false;
      });
    },

    formatDate(datetime) {
      if (!datetime) return '';
      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
    },
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '');
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "expressInterception.scss";
</style>
